import { Pipe, PipeTransform } from '@angular/core';
import { IUserInfo } from '../models/user.model';
import { Observable } from 'rxjs/Observable';
import { AuthData } from '../providers/auth';

@Pipe({
  name: 'userInfo'
})

export class UserInfoPipe implements PipeTransform {

  constructor(
    private authProvider: AuthData
  ) {}

  transform(value: string, clientId: string): Observable<IUserInfo> {
    return this.authProvider.getUserDB(value, clientId);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/user-info.pipe.ts